import Typography from "antd/lib/typography";
import clsx from "clsx";
import { ReactNode } from "react";

import { IUserResource } from "@sol/sdk";
import { Skeleton } from "@sol/uikit/feedback/Skeleton/Skeleton";

import { UserRow } from "./UserRow";

type Props = {
    title: string;
    subtitle?: string | ReactNode;
    footer?: ReactNode;
    noUserMessage: string;
    users?: IUserResource[];
    isLoading?: boolean;
    onUserRemove: (userEmail: string) => void;
    className?: string;
};

export const UserPickerList = ({
    title,
    subtitle,
    footer,
    noUserMessage,
    users = [],
    isLoading = false,
    onUserRemove,
    className,
}: Props) => {
    let children;

    if (isLoading) {
        children = (
            <ul className={clsx("mt-ant flex flex-col gap-ant", className)}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <li key={index}>
                        <Skeleton
                            avatar={{ size: 40, shape: "circle" }}
                            paragraph={false}
                            className="[&_h3]:mb-0!"
                            active
                        />
                    </li>
                ))}
            </ul>
        );
    } else if (users.length < 1) {
        children = (
            <Typography.Text className="mt-9" data-cy="no-user-message">
                {noUserMessage}
            </Typography.Text>
        );
    } else {
        children = (
            <ul className="mt-12 mb-6 flex max-h-96 flex-col gap-4 overflow-auto p-0" data-cy="user-picker-list">
                {users.map(user => (
                    <li key={user.email}>
                        <UserRow user={user} actionType="remove" onClick={() => onUserRemove(user.email)} />
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <div className={clsx(className, "flex h-full flex-col justify-between")}>
            <div>
                <Typography.Title level={3} className="text-ant-h3">
                    {title}
                </Typography.Title>
                {subtitle}
                {children}
            </div>
            {footer && footer}
        </div>
    );
};
